export enum MessagesEnum {
    ITINERARY_DISCLAIMER = 'Kindly note that itinerary activities and visiting points may be adjusted in response to destination-specific regulations, weather conditions, or unexpected events.'
}